var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99993 10.0001C2.10666 10.0004 1.9035 10.0412 1.99993 10.0001C2.09636 9.95892 1.93269 10.0747 1.99993 10.0001L5.99993 6.00008C6.10501 5.88506 5.99993 5.14897 5.99993 5.00008C5.99993 4.85119 6.10501 5.1151 5.99993 5.00008L1.99993 1.00008C1.87867 0.868811 2.18884 1.01575 1.99993 1.00008C1.81102 0.984409 1.14583 0.890973 0.99993 1.00008C0.854034 1.10919 1.01735 1.83011 0.99993 2.00008C0.982512 2.17005 0.878666 1.86881 0.99993 2.00008L3.99993 6.00008L0.99993 9.00008C0.912569 9.09443 1.01699 8.87824 0.99993 9.00008C0.98287 9.12192 0.941308 9.88918 0.99993 10.0001C1.05855 10.111 0.884116 9.9351 0.99993 10.0001C1.11574 10.0651 1.86345 10.0015 1.99993 10.0001Z",
    fill: "#232945"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/Arrow_right.a2ce4cb1d3ec295a795f975c36b91298.svg";
export { ForwardRef as ReactComponent };